
export default function Projects() {
  const projects = [
    {
      title: '大手通信会社 DX推進支援',
      rate: '160万円〜200万円／月',
      workload: '60%〜100%',
      tasks: ['DX推進企画', 'サポート提案', '要件定義', 'PMO支援'],
      period: '6ヶ月〜長期',
      image: 'https://public.readdy.ai/ai/img_res/3321669891f29991ef2a5832cbbaa294.jpg'
    },
    {
      title: '大手製造業 データ活用支援',
      rate: '170万円〜210万円／月',
      workload: '50%〜80%',
      tasks: ['データ活用構想', '業務整理', 'PoC支援', 'ベンダー調整'],
      period: '6ヶ月〜12ヶ月',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20manufacturing%20facility%20with%20data%20analytics%20visualization%2C%20modern%20industrial%20setting%20with%20digital%20dashboards%20and%20business%20intelligence%20systems%2C%20professional%20consulting%20workspace%20with%20navy%20blue%20color%20scheme%20and%20gold%20highlights%2C%20clean%20sophisticated%20design%2C%20high-quality%20business%20photography&width=400&height=250&seq=proj2&orientation=landscape'
    },
    {
      title: '大手リテール 企業DX支援',
      rate: '160万円〜190万円／月',
      workload: '60%〜100%',
      tasks: ['業務改革支援', '要件定義', 'PMO支援', 'ベンダー管理'],
      period: '6ヶ月〜長期',
      image: 'https://readdy.ai/api/search-image?query=Modern%20retail%20corporate%20headquarters%20with%20digital%20transformation%20technology%2C%20professional%20business%20consulting%20environment%20with%20strategic%20planning%20displays%20and%20data%20visualization%2C%20elegant%20navy%20blue%20and%20gold%20color%20palette%2C%20sophisticated%20minimalist%20design%2C%20premium%20business%20atmosphere%2C%20photorealistic%20quality&width=400&height=250&seq=proj3&orientation=landscape'
    }
  ];

  return (
    <section id="projects" className="py-12 bg-[#0d1b2e]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          案件の例
        </h2>
        <div className="grid md:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {projects.map((project, index) => (
            <div key={index} className="bg-[#1a2f4e] rounded-lg overflow-hidden hover:shadow-xl transition-shadow border border-slate-700">
              <div className="w-full h-40">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-base mb-2 text-white">{project.title}</h3>
                <div className="space-y-1 text-xs text-slate-300">
                  <p><span className="font-semibold text-amber-400">単価：</span>{project.rate}</p>
                  <p><span className="font-semibold text-amber-400">稼働率：</span>{project.workload}</p>
                  <p><span className="font-semibold text-amber-400">業務内容：</span></p>
                  <ul className="list-disc list-inside pl-2 space-y-0.5">
                    {project.tasks.map((task, i) => (
                      <li key={i}>{task}</li>
                    ))}
                  </ul>
                  <p><span className="font-semibold text-amber-400">期間：</span>{project.period}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
